import { render } from "./eventRegistration.vue?vue&type=template&id=1a3202e5&scoped=true"
import script from "./eventRegistration.vue?vue&type=script&lang=js"
export * from "./eventRegistration.vue?vue&type=script&lang=js"

import "./eventRegistration.vue?vue&type=style&index=0&id=1a3202e5&lang=scss&scoped=true"
import "./eventRegistration.vue?vue&type=style&index=1&id=1a3202e5&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3202e5"]])

export default __exports__